/* ═══ FAIXA EM LAÇO QUE NUNCA FICA VAZIA — [2026-08-19] ═════════════════════
   🔴 O DEFEITO, medido antes de escrever uma linha:

       @1440   `.fita` (avisos do topo)  uma cópia 1021 px  → 419 px de vazio
               `.rolo` (a faixa verde)   uma cópia  858 px  → 582 px de vazio
       @2560   `.deps` (depoimentos)     uma cópia 2508 px  →  52 px de vazio

   O laço destas faixas é `transform:translateX(-50%)` sobre um conteúdo
   escrito DUAS vezes. Isso só fecha o círculo se METADE da fita for pelo menos
   tão larga quanto a tela — quando não é, o fim do primeiro conjunto entra em
   cena antes de o segundo chegar, e sobra buraco. **Duas cópias não é uma
   regra, é um chute sobre o tamanho do monitor.**

   🔑 A CORREÇÃO NÃO É "TRÊS CÓPIAS", É CONTAR. Três resolve 2560 e quebra em
     3840. Aqui a fita se duplica INTEIRA quantas vezes forem necessárias até
     que metade dela cubra a tela — em qualquer largura, hoje e num monitor que
     ainda não existe.

   🪤 DUPLICAR A FITA INTEIRA, E NÃO ITEM A ITEM. O `-50%` só fecha se o
     conteúdo for simétrico: dobrando tudo, o total é sempre 2ⁿ × o conjunto
     original e a metade cai exatamente numa emenda. Clonar item a item
     desalinharia a costura e o pulo apareceria.

   ⚠️ As cópias entram com `aria-hidden`: para quem usa leitor de tela, ler a
     mesma frase oito vezes é ruído, não conteúdo. */
(function () {
  'use strict';
  var FITAS = '.fita, .rolo, .deps';
  var TETO = 6;      /* trava de segurança: 2⁶ é mais que qualquer monitor */
  /* px por segundo, igual para todas as fitas — ver a nota da duração, lá
     embaixo. 🔑 NO CELULAR ELA CAI PARA 30 — [2026-08-25]. O tempo que uma
     frase fica INTEIRA na tela é `(tela − frase) ÷ velocidade`, e numa tela de
     390px a frase mais longa da faixa quase preenche tudo: a 45px/s ela
     aparecia inteira por 0,29s, medido em 24/08. Foi por isso que a fita chegou
     a ser empilhada; ele mandou fazê-la correr de novo, então o remédio passou
     a ser a velocidade. As três fitas continuam sincronizadas entre si, que era
     a razão de haver uma constante só. */
  var VELOCIDADE_LARGA = 45;

  function enche(f) {
    /* 🪤 NEM TODA `.fita` É UM LAÇO — [2026-08-22]. A barra de avisos do topo
       passou a mostrar UM aviso por vez, com os itens empilhados em
       `position:absolute`. Item absoluto não soma largura, então `scrollWidth`
       fica em zero, a conta abaixo nunca é satisfeita e o laço clona até o teto:
       medi 192 avisos onde deviam existir 3. Quem não é laço se marca no HTML e
       sai daqui — mais honesto que apertar o TETO, que só esconderia o defeito. */
    if (f.closest && f.closest('[data-sem-laco]')) return;
    /* 🪤 E FITA EMPILHADA TAMBÉM NÃO É LAÇO — [2026-08-24], e é EXATAMENTE o
       mesmo defeito de 22/08 por outra porta. Abaixo de 480px a faixa da home
       vira coluna (ver ettore-home-extra.css): as frases param de andar e ficam
       uma sobre a outra. Numa coluna a largura nunca cresce, então
       `f.scrollWidth < alvo` é sempre verdade e o laço clona até o teto —
       medi 384 itens onde devem existir 3, num celular, que é onde está 86% do
       tráfego e onde nó de DOM custa mais.
       📏 A lição de 22/08 dizia "item absoluto não soma largura". Coluna não
         soma largura pelo mesmo motivo. Então a pergunta certa não é "é
         absoluto?" e sim: **a largura pode crescer?** */
    if (getComputedStyle(f).flexDirection === 'column') return;
    var alvo = window.innerWidth * 2;
    var voltas = 0;
    while (f.scrollWidth < alvo && voltas++ < TETO) {
      var base = [].slice.call(f.children);
      if (!base.length) return;
      for (var i = 0; i < base.length; i++) {
        var c = base[i].cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        f.appendChild(c);
      }
    }

    /* 🔴 DOBRAR A FITA SEM DOBRAR O TEMPO ACELERA O LAÇO — ele viu na hora:
         *"agora eles estão muito rápidos, e não estão sincronizados; o de cima
          mega rápido, o de baixo menos um pouco"*.
       A animação percorre `-50%` da fita no tempo declarado no CSS. Com a fita
       duas vezes maior, ela percorre o DOBRO da distância nos mesmos segundos.
       📏 Medido depois da clonagem: 94, 55 e 66 px/s — a de cima quase o dobro
         das outras. E antes já eram 46, 55 e 33: **nunca estiveram
         sincronizadas**, só não dava para notar porque cada uma vivia numa
         parte diferente da página.
       🔑 O tempo passa a NASCER da distância: `duração = metade ÷ velocidade`.
         Uma velocidade só para as três, e ela se mantém igual em qualquer
         tela — numa tela maior a fita ganha mais cópias E mais segundos, na
         mesma proporção. */
    /* ⚠️ RELÊ A VELOCIDADE A CADA CORRIDA, não usa a do carregamento: girar o
       telefone dispara `tudo()` de novo, e a tela que era de 390px passa a ser
       de 844. Congelar o valor deixaria o computador andando a 30px/s depois de
       uma virada de tela. */
    var v = window.innerWidth <= 480 ? 30 : VELOCIDADE_LARGA;
    f.style.animationDuration = ((f.scrollWidth / 2) / v).toFixed(1) + 's';
  }

  function tudo() {
    var l = document.querySelectorAll(FITAS);
    for (var i = 0; i < l.length; i++) enche(l[i]);
  }

  /* 🔴 ESPERAR O DOCUMENTO NÃO É ZELO, É O CONSERTO. Este arquivo é carregado
     pelo CABEÇALHO, que é renderizado ANTES das seções onde vivem a faixa
     verde (`.rolo`) e a tira de depoimentos (`.deps`). Rodando na hora,
     `querySelectorAll` achava só a `.fita` — que mora no próprio cabeçalho — e
     as outras duas continuavam com o vazio. Medido: `.fita` foi de 12 para 24
     itens e as outras não saíram do lugar. **É a segunda vez neste projeto que
     um script do tema roda antes do alvo existir e falha em silêncio.** */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tudo);
  } else {
    tudo();
  }

  /* 🪤 SÓ CRESCE, NUNCA ENCOLHE. Remover clones ao estreitar a janela cortaria
     a fita no meio de uma volta e o salto seria visível. Sobra de conteúdo não
     custa nada; falta de conteúdo é o buraco. */
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(tudo, 250);
  });
})();
